const signup = {
  screenName: '',
  document: '',
  email: '',
  verificationTicket: '',
}

export { signup }
